<template>
    <div class="articleCard">
        <div class="content">
            <div v-if="articleData.hasOwnProperty('timestamp')" class="timestamp">{{ articleData.timestamp.toDate().toLocaleDateString('en-GB') }}</div>
            <div class="text" v-html="content"></div>
        </div>
    </div>
</template>

<script>
    import firebaseApp from '../firebaseInit';

    let hljs = require('highlight.js');

    // Actual default values
    let md = require('markdown-it')({
        highlight: function (str, lang) {
            if (lang && hljs.getLanguage(lang)) {
                try {
                    return '<pre class="hljs"><code>' +
                        hljs.highlight(lang, str, true).value +
                        '</code></pre>';
                } catch (__) {
                    console.log("Highlighting error!");
                }
            }

            return '<pre class="hljs"><code>' + md.utils.escapeHtml(str) + '</code></pre>'; // use external default escaping
        }
    });

    let storage = firebaseApp.storage;
    let db = firebaseApp.db;

    export default {
        name: 'Article',
        data: function() {
            return {
                content: "",
                articleData: {}
            }
        },
        watch: {
            '$route': 'loadArticle'
        },
        created: function () {
            this.loadArticle();
        },
        methods: {
            loadArticle: function() {
                const slug = this.$route.params.slug;

                let docRef = db.collection("articles").doc(slug);
                docRef.get().then((doc) => {
                    this.articleData = doc.data();
                });

                storage.ref(slug + '.md').getDownloadURL().then(
                    (url) => {
                        let xhr = new XMLHttpRequest();
                        xhr.responseType = 'blob';
                        xhr.onload = () => {
                            let blob = xhr.response;

                            let reader = new FileReader();

                            reader.onload = () => {
                                let text = reader.result;

                                let codeSplit = text.split('```');
                                let langs = [];
                                for (let i = 1; i < codeSplit.length; i+=2) {
                                    let lang = codeSplit[i].split("\n")[0];
                                    langs.push(lang);
                                }
                                this.content = md.render(text);
                                setTimeout(() => {
                                    document.getElementsByClassName('articleCard')[0].classList.add('visible');
                                    let codeBlocks = document.getElementsByClassName('hljs');
                                    for (let i = 0; i < codeBlocks.length; i++) {
                                        codeBlocks[i].setAttribute('data-lang', langs[i].trim());
                                    }
                                }, 100);
                            };

                            reader.readAsText(blob);
                        };
                        xhr.open('GET', url);
                        xhr.send();
                    }
                );
            }
        }
    }
</script>

<style scoped>
    .articleCard {
        opacity: 0;
        transition: 0.3s;

        background-color: white;
        display: flex;
        justify-content: center;
        padding-top: 96px;
        margin-bottom: 16px;
        border-radius: 5px;
        overflow-x: hidden;
    }

    .visible {
        opacity: 1;
    }

    .text {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-bottom: 16px;
    }

    /deep/ .text * {
        width: 60vw;
        text-align: left;
    }

    /deep/ img {
        max-width: 40vw;
        margin-left: 10vw;
    }

    /deep/ .hljs {
        font-family: "Fira Code", monospace;
        box-shadow: 0 5px 20px rgba(0, 0, 0, 0.5);
        font-size: 14px;
        width: 70vw;
    }

    @media screen and (orientation: portrait) {
        /deep/.text * {
            width: 80vw;
        }

        /deep/ .hljs {
            width: calc(100vw - 64px);
        }

        /deep/ img {
            margin-left: 0;
            max-width: 80vw;
        }
    }

    .content * {
        width: 60vw;
    }

    /deep/ .content p, /deep/ .content ul, /deep/ .hljs {
        margin-bottom: 16px;
    }

    /deep/ .content li {
        margin-bottom: 8px;
    }

    .timestamp {
        text-align: right;
        margin-bottom: 16px;
        color: #999999;
    }

    /deep/ .hljs::after {
        content: attr(data-lang);
        display: block;
        text-align: right;

        color: #999999;
    }
</style>